import { Dimension } from "@client/types";

export interface SizeValue {
  useAspectRatio: boolean;
  dimension: Dimension;
  dimensionSize: number;
  height: number;
  width: number;
  isLocked: boolean;
}

export const getActualHeight = (size: SizeValue): number | undefined =>
  size.useAspectRatio ? (size.dimension === Dimension.Height ? size.dimensionSize : undefined) : size.height;

export const getActualWidth = (size: SizeValue) =>
  size.useAspectRatio ? (size.dimension === Dimension.Width ? size.dimensionSize : undefined) : size.width;

export const SIZE_VALUE_REGEX = /^(false|true)\|(width|height)\|([\d.]+)\|([\d.]+)\|([\d.]+)\|(false|true)$/;
export const parseValue = (value: string): SizeValue => {
  const match = value.match(SIZE_VALUE_REGEX);
  if (!match) throw new Error(`BUG. Unexpected size format ${value}`);

  const parts = match;
  return {
    useAspectRatio: parts[1] === "true",
    dimension: <Dimension>parts[2],
    dimensionSize: +parts[3],
    width: +parts[4],
    height: +parts[5],
    isLocked: parts[6] === "true"
  };
};

export const serializeValue = (value: SizeValue): string =>
  `${value.useAspectRatio}|${value.dimension}|${value.dimensionSize}|${value.width}|${value.height}|${value.isLocked}`;
